"use client";

import { useEffect, useState } from "react";
import Link from "next/link";

export interface UrgencyBarData {
  pill: string;
  text: string;
  counter: string;
  ctaLabel: string;
  ctaHref: string;
}

const DISMISS_KEY = "gx-urgency-dismissed";

/** Top "Reforma Tributária em vigor" bar — dismissible; the dismissal sticks for the
 *  browser session (so it doesn't reappear on every navigation). */
export function UrgencyBar({ data }: { data: UrgencyBarData }) {
  const [open, setOpen] = useState(true);

  useEffect(() => {
    try {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- read persisted dismissal after hydration
      if (sessionStorage.getItem(DISMISS_KEY) === "1") setOpen(false);
    } catch {
      /* sessionStorage unavailable — keep it open */
    }
  }, []);

  function dismiss() {
    try {
      sessionStorage.setItem(DISMISS_KEY, "1");
    } catch {
      /* ignore */
    }
    setOpen(false);
  }

  if (!open) return null;
  return (
    <div className="urgency">
      <div className="urgency__inner">
        <span className="urgency__pill">{data.pill}</span>
        <span>{data.text}</span>
        <span className="urgency__counter">{data.counter}</span>
        <Link href={data.ctaHref}>{data.ctaLabel}</Link>
        <button className="urgency__close" aria-label="Fechar aviso" onClick={dismiss}>
          ×
        </button>
      </div>
    </div>
  );
}
